import React from "react";

export const Imprint = () => (
  <div className="box">
    <p>
      Settings Icon made by{" "}
      <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons">
        Smashicons
      </a>{" "}
      from{" "}
      <a href="https://www.flaticon.com/" title="Flaticon">
        www.flaticon.com
      </a>{" "}
      is licensed by{" "}
      <a
        href="http://creativecommons.org/licenses/by/3.0/"
        title="Creative Commons BY 3.0"
      >
        CC 3.0 BY
      </a>
    </p>
    <p>
      Share Icon made by{" "}
      <a 
        href="https://www.flaticon.com/authors/gregor-cresnar"
        title="Gregor Cresnar"
      >
        Gregor Cresnar
      </a>{" "}
      from{" "}
      <a href="https://www.flaticon.com/" title="Flaticon">
        www.flaticon.com
      </a>{" "}
      is licensed by{" "}
      <a
        href="http://creativecommons.org/licenses/by/3.0/"
        title="Creative Commons BY 3.0"
        target="_blank"
        rel="noopener noreferrer" 
      >
        CC 3.0 BY
      </a>
    </p>
    <p>
      Daisy Icon made by{" "}
      <a href="http://www.freepik.com" title="Freepik">
        Freepik
      </a>{" "}
      from{" "}
      <a href="https://www.flaticon.com/" title="Flaticon">
        www.flaticon.com
      </a>{" "}
      is licensed by{" "}
      <a
        href="http://creativecommons.org/licenses/by/3.0/"
        title="Creative Commons BY 3.0"
      >
        CC 3.0 BY
      </a>
    </p>
    <p>
      Cancel Icon made by{" "}
      <a href="https://www.flaticon.com/authors/hadrien" title="Hadrien">
        Hadrien
      </a>{" "}
      from{" "}
      <a href="https://www.flaticon.com/" title="Flaticon">
        www.flaticon.com
      </a>{" "}
      is licensed by{" "}
      <a
        href="http://creativecommons.org/licenses/by/3.0/"
        title="Creative Commons BY 3.0"
        target="_blank"
        rel="noopener noreferrer"
      >
        CC 3.0 BY
      </a>
    </p>
    <p>
      Tangerine-Regular.ttf: Copyright (c) 2010 by Toshi Omagari. All rights
      reserved.<br />
      Tangerine-Bold.ttf: Copyright (c) 2010 by Toshi Omagari. All rights
      reserved.
    </p>
    <p>
      THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
      IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
      FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
      THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
      LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
      FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
      DEALINGS IN THE SOFTWARE.
    </p>
    <p>
      We provide no guarantees about the accuracy of the translations. This app
      does not provide medical advice but is for informational purposes only.
    </p>
    <p>
      <strong>Privacy statement</strong>: We are not storing any of your
      information. Our hosting is done via netlify, you can read their DPA{" "}
      <a href="https://www.netlify.com/gdpr/">here</a>.
    </p>
    <p>
      <a href="https://ymmv.craftswerk.io/imprint/">Imprint</a>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/Imprint.js